import { ready } from '@titanio/utils'

import '@magnetita/accordion'
import tracking from '@modules/tracking'

import app from './app'
import router from './router'

ready(() => {
  setTimeout(app.loader(), 0)
  setTimeout(router.loader(), 0)
  setTimeout(tracking.loader(), 0)
})
